import React, { ButtonHTMLAttributes } from 'react';
import { ButtonVisualProps } from './types';
import { getButtonClasses, ButtonContent } from './utils';

type ButtonProps = ButtonVisualProps &
  ButtonHTMLAttributes<HTMLButtonElement> & {
    href?: never;
  };

const Button = ({
  children,
  variant,
  size = 'medium',
  isFullWidth,
  isLoading,
  StartIcon,
  EndIcon,
  className,
  disabled,
  ...props
}: ButtonProps) => {
  const isDisabledAttr = disabled || isLoading;

  const classes = getButtonClasses({
    variant,
    size,
    isFullWidth,
    isLoading,
    StartIcon,
    EndIcon,
    disabled,
    className,
  });

  return (
    <button className={classes} disabled={isDisabledAttr} aria-disabled={isDisabledAttr} {...props}>
      <ButtonContent isLoading={isLoading} size={size} StartIcon={StartIcon} EndIcon={EndIcon}>
        {children}
      </ButtonContent>
    </button>
  );
};

export { Button, type ButtonProps };
